import { Point, Updatable } from '../interface';

class Vibrator implements Updatable {
  public readonly epsilon: number = 0.001;
  public vibrateReducingCoefficient: number = 0.8;
  public vibratePeriod: number = 2;
  public vibrateStrength: number = 0;
  public vibrateRadian: number = 0;
  private currentVibratePeriod: number = 0;
  private target?: Point;

  constructor(target?: Point) {
    if (target) {
      this.setTarget(target);
    }
  }

  public update(elapsed: number): void {
    this.applyVibration();
    this.reduceVibrate(elapsed);
  }

  public setTarget(target: Point): void {
    this.target = target;
  }

  public vibrate(strength: number, degree = Math.random() * 360): void {
    this.vibrateStrength = strength;
    this.vibrateRadian = (degree / 180) * Math.PI;
  }

  private applyVibration(): void {
    if (this.target) {
      this.target.x += Math.cos(this.vibrateRadian) * this.vibrateStrength;
      this.target.y += Math.sin(this.vibrateRadian) * this.vibrateStrength;
    }
  }

  private reduceVibrate(elapsed: number): void {
    this.currentVibratePeriod += elapsed;

    if (this.currentVibratePeriod >= this.vibratePeriod) {
      if (Math.abs(this.vibrateStrength) <= this.epsilon) {
        this.vibrateStrength = 0;
      } else {
        this.vibrateStrength = this.vibrateStrength * this.vibrateReducingCoefficient;
        this.vibrateRadian += Math.PI;
      }

      this.currentVibratePeriod -= this.vibratePeriod;
    }

    if (this.currentVibratePeriod < 0) {
      this.currentVibratePeriod = 0;
    }
  }
}

export default Vibrator;
